import ActionType from './action-type'
import * as Actions from './actions'
import {Api, type QuerySpecification} from '../../../api/Api'
import * as uuid from 'uuid'
import {ets, type QueryCancellation} from '../../../websocket/Queries'
import {type ThunkAction} from 'redux-thunk'
import {type AppState} from '../../types/app-state'
import {type EtsData} from './state'

const QUERY_PATH = 'latestEnterpriseThreatScore'
const QUERY_SCHEDULE = '10s'

const QUERY_PATH_LOCATION = 'latestLocationThreatScores'

export function fetchEts(
    location?: string | null,
): ThunkAction<QueryCancellation, AppState, Api, Actions.Action> {
    return (dispatch, _, api: Api): QueryCancellation => {
        dispatch(requestEtsAction())
        const query: QuerySpecification = location ? etsLocationQuery() : etsQuery()
        api.newQuery(query, (data) => {
            // @ts-expect-error have to revisit this whole thing
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            dispatch(receiveEtsAction(location ? data[location] : data))
        })

        return () => {
            api.cancelQuery({localId: query.localId})
        }
    }
}

export function requestEtsAction(): Actions.RequestEtsAction {
    return {
        type: ActionType.REQUEST_ETS,
    }
}

/**
 * CDS-6008. Clears the loading flag without touching the score, so a failed
 * fetch stops the widget spinning and leaves whatever was last received on
 * screen.
 */
export function etsRequestFailedAction(): Actions.EtsRequestFailedAction {
    return {
        type: ActionType.ETS_REQUEST_FAILED,
    }
}

export function receiveEtsAction(etsData: EtsData): Actions.ReceiveEtsAction {
    return {
        type: ActionType.RECEIVE_ETS,
        payload: etsData,
    }
}

function etsQuery(): QuerySpecification {
    return {
        path: QUERY_PATH,
        localId: `${ets}-${uuid.v4()}`,
        schedule: QUERY_SCHEDULE,
    }
}

function etsLocationQuery(): QuerySpecification {
    return {
        path: QUERY_PATH_LOCATION,
        localId: `${ets}-latestLocationThreatScores-${uuid.v4()}`,
        schedule: QUERY_SCHEDULE,
    }
}
